import React, { useCallback } from 'react'
import { Grid } from 'semantic-ui-react'
import InputField from '@commonComponents/formComponents/CustomInputField'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import DeleteIcon from '@commonComponents/deleteIcon'

const PreviousDocForm = (props) => {
  const {
    dataSource: {
      id,
      type,
      reference,
      description,
      quantity,
      unitOfMeasurement
    },
    translate,
    copyDocument,
    docTypeList,
    onChange,
    onSelect,
    onBlur,
    deleteData,
    tableName,
    prevDocValidation,
    preDocIdx,
    renderAtLast,
    isPreviousDocDisabled,
    markedDeleted
  } = props

  const onChangeHandler=useCallback(({target:{value,name}})=>
    onChange(id,tableName,{[name]:value}),
    [tableName,id,onChange])
  const onDropDownChange=useCallback((e, {value,name})=>{
    // debugger
    if(prevDocValidation) prevDocValidation(preDocIdx,name,value)
    onSelect(id,tableName,{[name]:value,id})
  },
  [tableName,id,onSelect, translate])
  const onBlurHandler=useCallback(({target:{value,name}})=>{
    if(prevDocValidation) prevDocValidation(preDocIdx,name,value)
    onBlur(tableName,{[name]:value?.trim(),id},name) 
  },
    [tableName,id,onBlur])
  
  return (
    <div  className="formContainer">  
      <div className="actionbtns">
        {copyDocument && copyDocument(translate)}
      </div> 
    <Grid.Row>
      <Grid.Column>
        <DropDown
          id={`type-${id}`}
          labelClass='text-none'
          label='DOC_TYPE'
          name="type"
          data={docTypeList}
          clearable
          value={type}
          text={type}
          onChange={onDropDownChange} 
          isDisabled={isPreviousDocDisabled}
        />
      </Grid.Column>

      <Grid.Column>
        <InputField
          id={`reference-${id}`}
          type='text'
          name="reference"
          label="DOC_REFERENCE"
          value={reference}
          clearInput={false}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
          isDisabled={isPreviousDocDisabled}
        />
      </Grid.Column>
      <Grid.Column>
      <InputField
          id={`description-${id}`}
          type='text'
          label="LINE"
          value={description}
          name="description"
          clearInput={false}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
          isDisabled={isPreviousDocDisabled}
        />

      </Grid.Column>

      {renderAtLast && renderAtLast({
        id,
        unitOfMeasurement,
        quantity,
        onChangeHandler,
        onBlurHandler,
        onDropDownChange,
        isPreviousDocDisabled
      })}
      
    </Grid.Row>
    <div className="actionbtns">
      {markedDeleted ? markedDeleted({id,tableName}):
       <DeleteIcon onClick={()=>deleteData(id,tableName)} />}
    </div>
    </div>
  )
}
PreviousDocForm.defaultProps = {
    translate:(value)=>value
  }
export default React.memo(PreviousDocForm)
